module.exports = __webpack_public_path__ + "static/media/clip_one.2899f7bd.mp3";